import React, { useState } from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Form from "react-bootstrap/Form";
import Alert from "@mui/material/Alert";
import SaveIcon from "@mui/icons-material/Save";
import { Container } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";

// Router
import { useParams } from "react-router-dom";

// Axious
import { resetPasswordConfirm } from "../services/login";
import { URL } from "../services/URL";

function RedefinirSenha() {
	const [novaSenha, setNovaSenha] = useState("");
	const [confirmarNovaSenha, setConfirmarNovaSenha] = useState("");
	const [isLoading, setIsLoading] = useState();
	const [response, setResponse] = useState(null);

	const params = useParams();

	const [error, setError] = useState({
		new_password: false,
		re_new_password: false,
	});

	const [helperText, setHelperText] = useState({
		new_password: "",
		re_new_password: "",
	});

	const validateHelperText = (errors) => {
		setHelperText({
			new_password: errors.new_password,
			re_new_password: errors.re_new_password,
		});
	};

	const validateError = (errors) => {
		let aux = {
			new_password: errors.new_password ? true : false,
			re_new_password: errors.re_new_password ? true : false,
		};

		setError(aux);
	};

	const redefinirSenha = (reset_password) => {
		resetPasswordConfirm(reset_password)
			.then(function (responses) {
				if (responses.status === 204) {
					setResponse({
						code: 204,
						message: "Senha modificada com sucesso."
					});
					window.location.replace(URL.REDIRECT);
				} 

				setIsLoading(false);
			})
			.catch(function (errors) {
				console.log(errors);

				setResponse({
					code: 400,
					message: "Não foi possível modificar a senha."
				});
				validateHelperText(errors.response.data);
				validateError(errors.response.data);

				setIsLoading(false);
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setIsLoading(true);

		const reset_password = {
			uid: params.uid,
			token: params.token,
			new_password: novaSenha,
			re_new_password: confirmarNovaSenha,
		};

		redefinirSenha(reset_password);
	};

	return (
		<Container className="mt-5">
			<Form noValidate onSubmit={handleSubmit}>
				<div className="d-flex justify-content-center">
					<h1>Redefinir Senha</h1>
				</div>
				<div className="p-4 row d-flex justify-content-center">
					<div style={{ maxWidth: 500 }}>
						<div>
							<div className="my-2 col-sm-12 col-md-12 col-lg-12">
								<TextField
									fullWidth
									label="Nova Senha"
									type="password"
									helperText={helperText.new_password}
									error={error.new_password}
									value={novaSenha}
									onChange={(e) =>
										setNovaSenha(e.target.value)
									}
								/>
							</div>
							<div className="my-2 col-sm-12 col-md-12 col-lg-12">
								<TextField
									fullWidth
									label="Confirmar senha"
									type="password"
									helperText={helperText.re_new_password}
									error={error.re_new_password}
									value={confirmarNovaSenha}
									onChange={(e) =>
										setConfirmarNovaSenha(e.target.value)
									}
								/>
							</div>
						</div>

						{isLoading && <CircularProgress size={25} className="mt-1" /> }

						<div className="d-flex justify-content-center mt-3">
							<Button
								variant="outlined"
								type="submit"
								size="medium"
								disabled={isLoading}
								startIcon={!isLoading && <SaveIcon />}
							>
								Enviar
							</Button>
						</div> 

						{response != null && (
							<div className="d-flex justify-content-center mt-3">
								<Alert
									severity={response.code === 204 ? "success" : "error"}
									sx={{ maxWidth: "500px" }}
								>
									<span>{response.message}</span>
								</Alert>
							</div>
						)}
					</div>
				</div>
			</Form>
		</Container>
	);
}

export default RedefinirSenha;
